import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormArray, FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { Subject } from 'rxjs';

import { DataService } from './../../data.service';
import {AppConfig} from './../../config';

@Component({
  selector: 'app-metabuttonview',
  templateUrl: './metabuttonview.component.html',
  styleUrls: ['./metabuttonview.component.scss']
})
export class MetabuttonViewComponent implements OnInit {

  metabutton:any;
  isLoading = false;
  isError = false;
  errorMessage = "";
  metabuttonId = "";
  name = "";
  metaobjectId = "";
  metaobjectName = "";
  parentobjectId = "";
  parentobjectName = "";
  embeddedObject = false;
  modifiedby = ""
  modifieddate = ""
  buttonAttributesDefnArr: any[];
  buttonAttributeArray = [];
  
  detailForm = this.fb.group({
    metaobjectid: '',
    metaobjectname: '',
    id: '',
    labelname: '',
    name: '',
    buttontype: '',
    actiontype: '',
    parentobjectid: '',
    parentobjectname: '',
    description: '',
    embeddedobject: new FormControl({value: false, disabled: true}),
    active: new FormControl({value: true, disabled: true}),
    attributes:{}
  });

  
  attributeForm: FormGroup;
  attributeitems: FormArray;

  createItem(a,t,v, p=''): FormGroup {
    return this.fb.group({
      attr: a,
      type: t,
      value: v,
      placeholder: p,
    });
  }

  addAttributeItem(a,t,v, p=''): void {
    this.attributeitems = this.attributeForm.get('attributeitems') as FormArray;
    this.attributeitems.push(this.createItem(a,t,v, p));
  }

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private appConfig: AppConfig,
    private dataService: DataService) {

     }

  ngOnInit() {
     
    this.route.queryParams.subscribe(params => {
      this.metabuttonId = this.route.snapshot.params.id;
      this.name = this.route.snapshot.params.name;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
      this.parentobjectId = this.route.snapshot.params.parentobjectid;
      if(this.parentobjectId == 'none') this.parentobjectId = "";
      this.parentobjectName = this.route.snapshot.params.parentobjectname;
      if(this.parentobjectName == 'none') this.parentobjectName = "";

      //always convert string to boolean while assigning to formcontrol ****
      var boolValue = (this.route.snapshot.params.embeddedobject =="true"); 
      this.embeddedObject = boolValue;      

    });


    this.attributeForm = this.fb.group({
      buttonid: '',
      name: '',
      attributeitems: this.fb.array([])
    });

    this.getMetabuttonById();
    
    this.buttonAttributesDefnArr = this.appConfig.buttonAttributes;

  }

  metaobjectDetail()
  {
        this.router.navigateByUrl('home/metaobjectdetail/'+ this.metaobjectId + "/" + this.metaobjectName);  
  }
  editMetaButton()
  {
    this.router.navigateByUrl('/home/metabutton/edit/' + this.metabuttonId + '/' + this.name + '/' + this.metaobjectId + 
            '/' + this.metaobjectName + '/' + (this.parentobjectId==''?'none': this.parentobjectId) + '/'+ (this.parentobjectName==''?'none': this.parentobjectName) + 
            '/' + this.embeddedObject );  
  }

  getMetabuttonById(){ 

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid:localStorage.getItem("crm_userid"),
      username:localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
      subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
      data: {
        metabutton: {
          id: this.metabuttonId
        }
      }
    }

    this.isLoading = true;
    this.dataService.getMetabuttonById(postOption).subscribe(
      res => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if(res.success == 1){
          this.metabutton=res.data.metabutton;
          if(this.metabutton != null)
          {
            this.metaobjectId = this.metabutton.metaobjectid;
            this.metaobjectName = this.metabutton.metaobjectname;

            this.detailForm.controls['metaobjectid'].setValue(this.metabutton.metaobjectid);
            this.detailForm.controls['metaobjectname'].setValue(this.metabutton.metaobjectname);                
            this.detailForm.controls['id'].setValue(this.metabutton.id);
            this.detailForm.controls['labelname'].setValue(this.metabutton.labelname);
            this.detailForm.controls['name'].setValue(this.metabutton.name);
            this.detailForm.controls['buttontype'].setValue(this.metabutton.buttontype);
            this.detailForm.controls['actiontype'].setValue(this.metabutton.actiontype);
            this.detailForm.controls['parentobjectid'].setValue(this.metabutton.parentobjectid);
            this.detailForm.controls['parentobjectname'].setValue(this.metabutton.parentobjectname);
            this.detailForm.controls['description'].setValue(this.metabutton.description);
            this.detailForm.controls['embeddedobject'].setValue(this.metabutton.embeddedobject);
            this.detailForm.controls['active'].setValue(this.metabutton.active);
            this.detailForm.controls['attributes'].setValue(this.metabutton.attributes);
            this.modifiedby = this.metabutton.modifiedby;
            this.modifieddate = this.metabutton.timezone;

            this.buttonAttributeArray = this.buttonAttributesDefnArr;

            var fgArray = new Array<FormGroup>();
            //transform json to attribute form controls
            for (let i = 0; i < this.buttonAttributeArray.length; i++) {
              var item = this.buttonAttributeArray[i];
              
              //get value from the attributes
              var value = this.metabutton.attributes[item.attr];
              if(value instanceof Array){
                value = JSON.stringify(value);
              }

              this.addAttributeItem(item.attr, item.type, value);
            }
        

          }
          this.isLoading = false;
        }
        else{
          console.log("no data");
          this.isLoading = false;
          //this.resetDetailFormControls();
        }
      },
      err =>{
        console.log("Error***:",err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
    
  }


}
